import { BillingOrderListPage, BillingOrderEditPage, BillingOrderCreatePage } from './imports';

export const billingOrderRoutes = [
  {
    path: 'billing-orders',
    children: [
      { element: <BillingOrderListPage />, index: true },
      { path: 'list', element: <BillingOrderListPage /> },
      { path: ':id/edit', element: <BillingOrderEditPage /> },
      { path: 'new', element: <BillingOrderCreatePage /> },
    ],
  },
];
